<template>
  <div>
    <Header />
    <div class="bg-light pb-5">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">{{ $t("about.title") }}</h2>
          <a href="#">{{ $t("about.breadcrumb_home") }}</a> <i class="ti ti-angle-right"></i>
          <span>{{ $t("about.breadcrumb_current") }}</span>
        </div>

        <div class="row mt-5 justify-content-center">
          <div class="col-lg-4">
            <h2 class="font-32 blue-color font-bold">{{ $t("about.header_title") }}</h2>
          </div>
        </div>

        <div class="row mt-5 mb-5 align-items-center">
          <div class="col-lg-5">
            <img :src="about1" class="round-10 w-100" />
          </div>

          <div class="col-lg-5">
            <h3 class="font-bold font-22 blue-color mt-mobile mb-4">{{ $t("about.section_title") }}</h3>

            <p>{{ $t("about.paragraph1") }}</p>

            <p>{{ $t("about.paragraph2") }}</p>

            <ul>
              <li>> {{ $t("about.list1_item1") }}</li>
              <li>> {{ $t("about.list1_item2") }}</li>
              <li>> {{ $t("about.list1_item3") }}</li>
            </ul>
          </div>
        </div>

        <div class="row justify-content-center align-items-center">
          <div class="col-lg-9">
            <p class="text-center">{{ $t("about.paragraph3") }}</p>
          </div>
        </div>

        <div class="row mt-5 mb-5 align-items-center">
          <div class="col-lg-5">
            <h3 class="font-bold font-22 blue-color mb-4">{{ $t("about.section_title") }}</h3>

            <ul>
              <li>> {{ $t("about.list2_item1") }}</li>
              <li>> {{ $t("about.list2_item2") }}</li>
              <li>> {{ $t("about.list2_item3") }}</li>
            </ul>
          </div>
          <div class="col-lg-5 offset-lg-1">
            <img :src="about2" class="round-10 w-100" />
          </div>
        </div>
      </div>
    </div>

    <div class="service-list p-60">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Service />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import about1 from "@/assets/images/about-img-1.jpg";
  import about2 from "@/assets/images/about-img-2.jpg";
  import Service from "@/components/Service.vue";
  export default {
    components: {
      Header,
      Footer,
      Service,
    },
    data() {
      return {
        about1,
        about2,
      };
    },
  };
</script>
